// Array of all WADMKK values extracted from the document
export const KABUPATEN = [
    "Aceh Barat",
    "Aceh Barat Daya",
    "Aceh Besar",
    "Aceh Jaya",
    "Aceh Selatan",
    "Aceh Singkil",
    "Aceh Tamiang",
    "Aceh Tengah",
    "Aceh Tenggara",
    "Aceh Timur",
    "Aceh Utara",
    "Agam",
    "Alor",
    "Asahan",
    "Asmat",
    "Badung",
    "Balangan",
    "Bandung",
    "Bandung Barat",
    "Banggai",
    "Banggai Kepulauan",
    "Banggai Laut",
    "Bangka",
    "Bangka Barat",
    "Bangka Selatan",
    "Bangka Tengah",
    "Bangkalan",
    "Bangli",
    "Banjar",
    "Banjarnegara",
    "Bantaeng",
    "Bantul",
    "Banyuasin",
    "Banyumas",
    "Banyuwangi",
    "Barito Kuala",
    "Barito Selatan",
    "Barito Timur",
    "Barito Utara",
    "Barru",
    "Batang",
    "Batanghari",
    "Batu Bara",
    "Bekasi",
    "Belitung",
    "Belitung Timur",
    "Belu",
    "Bener Meriah",
    "Bengkalis",
    "Bengkayang",
    "Bengkulu Selatan",
    "Bengkulu Tengah",
    "Bengkulu Utara",
    "Berau",
    "Biak Numfor",
    "Bima",
    "Bintan",
    "Bireuen",
    "Blitar",
    "Blora",
    "Boalemo",
    "Bogor",
    "Bojonegoro",
    "Bolaang Mongondow",
    "Bolaang Mongondow Selatan",
    "Bolaang Mongondow Timur",
    "Bolaang Mongondow Utara",
    "Bombana",
    "Bondowoso",
    "Bone",
    "Bone Bolango",
    "Boven Digoel",
    "Boyolali",
    "Brebes",
    "Buleleng",
    "Bulukumba",
    "Bulungan",
    "Bungo",
    "Buol",
    "Buru",
    "Buru Selatan",
    "Buton",
    "Buton Selatan",
    "Buton Tengah",
    "Buton Utara",
    "Ciamis",
    "Cianjur",
    "Cilacap",
    "Cirebon",
    "Dairi",
    "Deiyai",
    "Deli Serdang",
    "Demak",
    "Dharmasraya",
    "Dogiyai",
    "Dompu",
    "Donggala",
    "Empat Lawang",
    "Ende",
    "Enrekang",
    "Fak Fak",
    "Flores Timur",
    "Garut",
    "Gayo Lues",
    "Gianyar",
    "Gorontalo",
    "Gorontalo Utara",
    "Gowa",
    "Gresik",
    "Grobogan",
    "Gunung Mas",
    "Gunungkidul",
    "Halmahera Barat",
    "Halmahera Selatan",
    "Halmahera Tengah",
    "Halmahera Timur",
    "Halmahera Utara",
    "Hulu Sungai Selatan",
    "Hulu Sungai Tengah",
    "Hulu Sungai Utara",
    "Humbang Hasundutan",
    "Indragiri Hilir",
    "Indragiri Hulu",
    "Indramayu",
    "Intan Jaya",
    "Jayapura",
    "Jayawijaya",
    "Jember",
    "Jembrana",
    "Jeneponto",
    "Jepara",
    "Jombang",
    "Kaimana",
    "Kampar",
    "Kapuas",
    "Kapuas Hulu",
    "Karanganyar",
    "Karangasem",
    "Karawang",
    "Karimun",
    "Karo",
    "Katingan",
    "Kaur",
    "Kayong Utara",
    "Kebumen",
    "Kediri",
    "Keerom",
    "Kendal",
    "Kepahiang",
    "Kepulauan Anambas",
    "Kepulauan Aru",
    "Kepulauan Mentawai",
    "Kepulauan Meranti",
    "Kepulauan Sangihe",
    "Kepulauan Selayar",
    "Kepulauan Siau Tagulandang Biaro",
    "Kepulauan Sula",
    "Kepulauan Talaud",
    "Kepulauan Tanimbar",
    "Kepulauan Yapen",
    "Kerinci",
    "Ketapang",
    "Klaten",
    "Klungkung",
    "Kolaka",
    "Kolaka Timur",
    "Kolaka Utara",
    "Konawe",
    "Konawe Kepulauan",
    "Konawe Selatan",
    "Konawe Utara",
    "Kota Administrasi Jakarta Barat",
    "Kota Administrasi Jakarta Pusat",
    "Kota Administrasi Jakarta Selatan",
    "Kota Administrasi Jakarta Timur",
    "Kota Administrasi Jakarta Utara",
    "Kota Ambon",
    "Kota Balikpapan",
    "Kota Banda Aceh",
    "Kota Bandar Lampung",
    "Kota Bandung",
    "Kota Banjar",
    "Kota Banjarbaru",
    "Kota Banjarmasin",
    "Kota Batam",
    "Kota Batu",
    "Kota Bau Bau",
    "Kota Bekasi",
    "Kota Bengkulu",
    "Kota Bima",
    "Kota Binjai",
    "Kota Bitung",
    "Kota Blitar",
    "Kota Bogor",
    "Kota Bontang",
    "Kota Bukittinggi",
    "Kota Cilegon",
    "Kota Cimahi",
    "Kota Cirebon",
    "Kota Denpasar",
    "Kota Depok",
    "Kota Dumai",
    "Kota Gorontalo",
    "Kota Gunungsitoli",
    "Kota Jambi",
    "Kota Jayapura",
    "Kota Kediri",
    "Kota Kendari",
    "Kota Kotamobagu",
    "Kota Kupang",
    "Kota Langsa",
    "Kota Lhokseumawe",
    "Kota Lubuk Linggau",
    "Kota Madiun",
    "Kota Magelang",
    "Kota Makassar",
    "Kota Malang",
    "Kota Manado",
    "Kota Mataram",
    "Kota Medan",
    "Kota Metro",
    "Kota Mojokerto",
    "Kota Padang",
    "Kota Padang Panjang",
    "Kota Padang Sidempuan",
    "Kota Pagar Alam",
    "Kota Palangkaraya",
    "Kota Palembang",
    "Kota Palopo",
    "Kota Palu",
    "Kota Pangkal Pinang",
    "Kota Pare Pare",
    "Kota Pariaman",
    "Kota Pasuruan",
    "Kota Payakumbuh",
    "Kota Pekalongan",
    "Kota Pekanbaru",
    "Kota Pematangsiantar",
    "Kota Pontianak",
    "Kota Prabumulih",
    "Kota Probolinggo",
    "Kota Sabang",
    "Kota Salatiga",
    "Kota Samarinda",
    "Kota Sawahlunto",
    "Kota Semarang",
    "Kota Serang",
    "Kota Singkawang",
    "Kota Solok",
    "Kota Sorong",
    "Kota Subulussalam",
    "Kota Sukabumi",
    "Kota Sungai Penuh",
    "Kota Surabaya",
    "Kota Surakarta",
    "Kota Tangerang",
    "Kota Tangerang Selatan",
    "Kota Tanjung Balai",
    "Kota Tanjung Pinang",
    "Kota Tarakan",
    "Kota Tasikmalaya",
    "Kota Tebing Tinggi",
    "Kota Tegal",
    "Kota Ternate",
    "Kota Tidore Kepulauan",
    "Kota Tomohon",
    "Kota Tual",
    "Kota Yogyakarta",
    "Kotabaru",
    "Kotawaringin Barat",
    "Kotawaringin Timur",
    "Kuantan Singingi",
    "Kubu Raya",
    "Kudus",
    "Kulon Progo",
    "Kuningan",
    "Kupang",
    "Kutai Barat",
    "Kutai Kartanegara",
    "Kutai Timur",
    "Labuhanbatu",
    "Labuhanbatu Selatan",
    "Labuhanbatu Utara",
    "Lahat",
    "Lamandau",
    "Lamongan",
    "Lampung Barat",
    "Lampung Selatan",
    "Lampung Tengah",
    "Lampung Timur",
    "Lampung Utara",
    "Landak",
    "Langkat",
    "Lanny Jaya",
    "Lebak",
    "Lebong",
    "Lembata",
    "Lima Puluh Kota",
    "Lingga",
    "Lombok Barat",
    "Lombok Tengah",
    "Lombok Timur",
    "Lombok Utara",
    "Lumajang",
    "Luwu",
    "Luwu Timur",
    "Luwu Utara",
    "Madiun",
    "Magelang",
    "Magetan",
    "Mahakam Ulu",
    "Majalengka",
    "Majene",
    "Malaka",
    "Malang",
    "Malinau",
    "Maluku Barat Daya",
    "Maluku Tengah",
    "Maluku Tenggara",
    "Mamasa",
    "Mamberamo Raya",
    "Mamberamo Tengah",
    "Mamuju",
    "Mamuju Tengah",
    "Mandailing Natal",
    "Manggarai",
    "Manggarai Barat",
    "Manggarai Timur",
    "Manokwari",
    "Manokwari Selatan",
    "Mappi",
    "Maros",
    "Maybrat",
    "Melawi",
    "Mempawah",
    "Merangin",
    "Merauke",
    "Mesuji",
    "Mimika",
    "Minahasa",
    "Minahasa Selatan",
    "Minahasa Tenggara",
    "Minahasa Utara",
    "Mojokerto",
    "Morowali",
    "Morowali Utara",
    "Muara Enim",
    "Muaro Jambi",
    "Muko Muko",
    "Muna",
    "Muna Barat",
    "Murung Raya",
    "Musi Banyuasin",
    "Musi Rawas",
    "Musi Rawas Utara",
    "Nabire",
    "Nagan Raya",
    "Nagekeo",
    "Natuna",
    "Nduga",
    "Ngada",
    "Nganjuk",
    "Ngawi",
    "Nias",
    "Nias Barat",
    "Nias Selatan",
    "Nias Utara",
    "Nunukan",
    "Ogan Ilir",
    "Ogan Komering Ilir",
    "Ogan Komering Ulu",
    "Ogan Komering Ulu Selatan",
    "Ogan Komering Ulu Timur",
    "Pacitan",
    "Padang Lawas",
    "Padang Lawas Utara",
    "Padang Pariaman",
    "Pahuwato",
    "Pakpak Bharat",
    "Pamekasan",
    "Pandeglang",
    "Pangandaran",
    "Pangkajene Kepulauan",
    "Paniai",
    "Parigi Moutong",
    "Pasaman",
    "Pasaman Barat",
    "Pasangkayu",
    "Paser",
    "Pasuruan",
    "Pati",
    "Pegunungan Arfak",
    "Pegunungan Bintang",
    "Pekalongan",
    "Pelalawan",
    "Pemalang",
    "Penajam Paser Utara",
    "Penukal Abab Lematang Ilir",
    "Pesawaran",
    "Pesisir Barat",
    "Pesisir Selatan",
    "Pidie",
    "Pidie Jaya",
    "Pinrang",
    "Polewali Mandar",
    "Ponorogo",
    "Poso",
    "Pringsewu",
    "Probolinggo",
    "Pulang Pisau",
    "Pulau Morotai",
    "Pulau Taliabu",
    "Puncak",
    "Puncak Jaya",
    "Purbalingga",
    "Purwakarta",
    "Purworejo",
    "Raja Ampat",
    "Rejang Lebong",
    "Rembang",
    "Rokan Hilir",
    "Rokan Hulu",
    "Rote Ndao",
    "Sabu Raijua",
    "Sambas",
    "Samosir",
    "Sampang",
    "Sanggau",
    "Sarmi",
    "Sarolangun",
    "Sekadau",
    "Seluma",
    "Semarang",
    "Seram Bagian Barat",
    "Seram Bagian Timur",
    "Serang",
    "Serdang Bedagai",
    "Seruyan",
    "Siak",
    "Sidenreng Rappang",
    "Sidoarjo",
    "Sigi",
    "Sijunjung",
    "Sikka",
    "Simalungun",
    "Simeulue",
    "Sinjai",
    "Sintang",
    "Situbondo",
    "Sleman",
    "Solok",
    "Solok Selatan",
    "Soppeng",
    "Sorong",
    "Sorong Selatan",
    "Sragen",
    "Subang",
    "Sukabumi",
    "Sukamara",
    "Sukoharjo",
    "Sumba Barat",
    "Sumba Barat Daya",
    "Sumba Tengah",
    "Sumba Timur",
    "Sumbawa",
    "Sumbawa Barat",
    "Sumedang",
    "Sumenep",
    "Supiori",
    "Tabalong",
    "Tabanan",
    "Takalar",
    "Tambrauw",
    "Tana Tidung",
    "Tana Toraja",
    "Tanah Bumbu",
    "Tanah Datar",
    "Tanah Laut",
    "Tangerang",
    "Tanggamus",
    "Tanjung Jabung Barat",
    "Tanjung Jabung Timur",
    "Tapanuli Selatan",
    "Tapanuli Tengah",
    "Tapanuli Utara",
    "Tapin",
    "Tasikmalaya",
    "Tebo",
    "Tegal",
    "Teluk Bintuni",
    "Teluk Wondama",
    "Temanggung",
    "Timor Tengah Selatan",
    "Timor Tengah Utara",
    "Toba Samosir",
    "Tojo Una Una",
    "Toli Toli",
    "Tolikara",
    "Toraja Utara",
    "Trenggalek",
    "Tuban",
    "Tulang Bawang",
    "Tulang Bawang Barat",
    "Tulungagung",
    "Wajo",
    "Wakatobi",
    "Waropen",
    "Way Kanan",
    "Wonogiri",
    "Wonosobo",
    "Yahukimo",
    "Yalimo"
];

export const REGION_INDEX_TO_KABUPATEN_INDEX = [
    [0], [1], [2], [3], [4], [5], [6], [7], [8], [9], [10], [11], [12], [13], [14], [15], [16], [17], 
    [18], [19], [20], [21], [22], [23], [24], [25], [26], [27], [28], [29], [30], [31], [32], [33], 
    [34], [35], [36], [37], [38], [39], [40], [41], [42], [43], [44], [45], [46], [47], [48], [49], 
    [50], [51], [52], [53], [54], [55], [56], [57], [58], [59], [60], [61], [62], [63], [64], [65], 
    [66], [67], [68], [69], [70], [71], [72], [73], [74], [75], [76], [77], [78], [79], [80], [81], 
    [82], [83], [84], [85], [86], [87], [88], [89], [90], [91], [92], [93], [94], [95], [96], [97], 
    [98], [99], [100], [101], [102], [103], [104], [105], [106], [107], [108], [109], [110], [111], 
    [112], [113], [114], [115], [116], [117], [118], [119], [120], [121], [122], [123], [124], [125], 
    [126], [127], [128], [129], [130], [131], [132], [133], [134], [135], [136], [137], [138], [139], 
    [140], [141], [142], [143], [144], [145], [146], [147], [148], [149], [150], [151], [152], [153], 
    [154], [155], [156], [157], [158], [159], [160], [161], [162], [163], [164], [165], [166], [167], 
    [168], [169], [170], [171], [172], [173], [174], [175], [176], [177], [178], [179], [180], [181], 
    [182], [183], [184], [185], [186], [187], [188], [189], [190], [191], [192], [193], [194], [195], 
    [196], [197], [198], [199], [200], [201], [202], [203], [204], [205], [206], [207], [208], [209], 
    [210], [211], [212], [213], [214], [215], [216], [217], [218], [219], [220], [221], [222], [223], 
    [224], [225], [226], [227], [228], [229], [230], [231], [232], [233], [234], [235], [236], [237], 
    [238], [239], [240], [241], [242], [243], [244], [245], [246], [247], [248], [249], [250], [251], 
    [252], [253], [254], [255], [256], [257], [258], [259], [260], [261], [262], [263], [264], [265], 
    [266], [267], [268], [269], [270], [271], [272], [273], [274], [275], [276], [277], [278], [279], 
    [280], [281], [282], [283], [284], [285], [286], [287], [288], [289], [290], [291], [292], [293], 
    [294], [295], [296], [297], [298], [299], [300], [301], [302], [303], [304], [305], [306], [307], 
    [308], [309], [310], [311], [312], [313], [314], [315], [316], [317], [318], [319], [320], [321], 
    [322], [323], [324], [325], [326], [327], [328], [329], [330], [331], [332], [333], [334], [335], 
    [336], [337], [338], [339], [340], [341], [342], [343], [344], [345], [346], [347], [348], [349], 
    [350], [351], [352], [353], [354], [355], [356], [357], [358], [359], [360], [361], [362], [363], 
    [364], [365], [366], [367], [368], [369], [370], [371], [372], [373], [374], [375], [376], [377], 
    [378], [379], [380], [381], [382], [383], [384], [385], [386], [387], [388], [389], [390], [391], 
    [392], [393], [394], [395], [396], [397], [398], [399], [400], [401], [402], [403], [404], [405], 
    [406], [407], [408], [409], [410], [411], [412], [413], [414], [415], [416], [417], [418], [419], 
    [420], [421], [422], [423], [424], [425], [426], [427], [428], [429], [430], [431], [432], [433], 
    [434], [435], [436], [437], [438], [439], [440], [441], [442], [443], [444], [445], [446], [447], 
    [448], [449], [450], [451], [452], [453], [454], [455], [456], [457], [458], [459], [460], [461], 
    [462], [463], [464], [465], [466], [467], [468], [469], [470], [471], [472], [473], [474], [475], 
    [476], [477], [478], [479], [480], [481], [482], [483], [484], [485], [486], [487], [488], [489], 
    [490], [491], [492], [493], [494], [495], [496], [497], [498], [499], [500], [501], [502], [503], 
    [504], [505], [506], [507], [508], [509], [510], [511]
];

// Province bitflag assignments in hexadecimal, ordered west to east
const PROVINCE_BITFLAGS = {
    "Aceh": 0x1,                      // 2^0
    "North Sumatra": 0x2,             // 2^1
    "West Sumatra": 0x4,              // 2^2
    "Riau": 0x8,                      // 2^3
    "Riau Islands": 0x10,             // 2^4
    "Jambi": 0x20,                    // 2^5
    "Bengkulu": 0x40,                 // 2^6
    "South Sumatra": 0x80,            // 2^7
    "Bangka Belitung": 0x100,         // 2^8
    "Lampung": 0x200,                 // 2^9
    "Banten": 0x400,                  // 2^10
    "Jakarta": 0x800,                 // 2^11
    "West Java": 0x1000,              // 2^12
    "Central Java": 0x2000,           // 2^13
    "Yogyakarta": 0x4000,             // 2^14
    "East Java": 0x8000,              // 2^15
    "Bali": 0x10000,                  // 2^16
    "West Nusa Tenggara": 0x20000,    // 2^17
    "East Nusa Tenggara": 0x40000,    // 2^18
    "West Kalimantan": 0x80000,       // 2^19
    "Central Kalimantan": 0x100000,   // 2^20
    "South Kalimantan": 0x200000,     // 2^21
    "East Kalimantan": 0x400000,      // 2^22
    "North Kalimantan": 0x800000,     // 2^23
    "West Sulawesi": 0x1000000,       // 2^24
    "South Sulawesi": 0x2000000,      // 2^25
    "Central Sulawesi": 0x4000000,    // 2^26
    "Southeast Sulawesi": 0x8000000,  // 2^27
    "Gorontalo": 0x10000000,          // 2^28
    "North Sulawesi": 0x20000000,     // 2^29
    "Maluku": 0x40000000,             // 2^30
    "North Maluku": 0x40000000,       // 2^31
    "West Papua": 0x80000000,        // 2^32
    "Papua": 0x80000000              // 2^33
  };

  // The KABUPATEN_INDEX_TO_BITFLAG array with province bitflags in hex
export const KABUPATEN_INDEX_TO_BITFLAG = [
    // Aceh regencies - all use Aceh bitflag (0x1)
    0x1, // Aceh Barat
    0x1, // Aceh Barat Daya
    0x1, // Aceh Besar
    0x1, // Aceh Jaya
    0x1, // Aceh Selatan
    0x1, // Aceh Singkil
    0x1, // Aceh Tamiang
    0x1, // Aceh Tengah
    0x1, // Aceh Tenggara
    0x1, // Aceh Timur
    0x1, // Aceh Utara
    
    // West Sumatra (Sumatera Barat) regencies - all use West Sumatra bitflag (0x4)
    0x4, // Agam
    
    // East Nusa Tenggara (Nusa Tenggara Timur) regencies
    0x40000, // Alor
    
    // North Sumatra (Sumatera Utara) regencies
    0x2, // Asahan
    
    // Papua regencies - all use Papua bitflag (0x80000000)
    0x80000000, // Asmat
    
    // Bali regencies
    0x10000, // Badung
    
    // South Kalimantan (Kalimantan Selatan) regencies
    0x200000, // Balangan
    
    // West Java (Jawa Barat) regencies
    0x1000, // Bandung
    0x1000, // Bandung Barat
    
    // Central Sulawesi (Sulawesi Tengah) regencies
    0x4000000, // Banggai
    0x4000000, // Banggai Kepulauan
    0x4000000, // Banggai Laut
    
    // Bangka Belitung Islands (Kepulauan Bangka Belitung) regencies
    0x100, // Bangka
    0x100, // Bangka Barat
    0x100, // Bangka Selatan
    0x100, // Bangka Tengah
    
    // East Java (Jawa Timur) regencies
    0x8000, // Bangkalan
    
    // Bali regencies
    0x10000, // Bangli
    
    // South Kalimantan (Kalimantan Selatan) regencies
    0x200000, // Banjar
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Banjarnegara
    
    // South Sulawesi (Sulawesi Selatan) regencies
    0x2000000, // Bantaeng
    
    // Yogyakarta (DIY) regencies
    0x4000, // Bantul
    
    // South Sumatra (Sumatera Selatan) regencies
    0x80, // Banyuasin
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Banyumas
    
    // East Java (Jawa Timur) regencies
    0x8000, // Banyuwangi
    
    // South Kalimantan (Kalimantan Selatan) regencies
    0x200000, // Barito Kuala
    
    // Central Kalimantan (Kalimantan Tengah) regencies
    0x100000, // Barito Selatan
    0x100000, // Barito Timur
    0x100000, // Barito Utara
    
    // South Sulawesi (Sulawesi Selatan) regencies
    0x2000000, // Barru
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Batang
    
    // Jambi regencies
    0x20, // Batanghari
    
    // North Sumatra (Sumatera Utara) regencies
    0x2, // Batu Bara
    
    // West Java (Jawa Barat) regencies
    0x1000, // Bekasi
    
    // Bangka Belitung Islands (Kepulauan Bangka Belitung) regencies
    0x100, // Belitung
    0x100, // Belitung Timur
    
    // East Nusa Tenggara (Nusa Tenggara Timur) regencies
    0x40000, // Belu
    
    // Aceh regencies
    0x1, // Bener Meriah
    
    // Riau regencies
    0x8, // Bengkalis
    
    // West Kalimantan (Kalimantan Barat) regencies
    0x80000, // Bengkayang
    
    // Bengkulu regencies
    0x40, // Bengkulu Selatan
    0x40, // Bengkulu Tengah
    0x40, // Bengkulu Utara
    
    // East Kalimantan (Kalimantan Timur) regencies
    0x400000, // Berau
    
    // Papua regencies
    0x80000000, // Biak Numfor
    
    // West Nusa Tenggara (Nusa Tenggara Barat) regencies
    0x20000, // Bima
    
    // Riau Islands (Kepulauan Riau) regencies
    0x10, // Bintan
    
    // Aceh regencies
    0x1, // Bireuen
    
    // East Java (Jawa Timur) regencies
    0x8000, // Blitar
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Blora
    
    // Gorontalo regencies
    0x10000000, // Boalemo
    
    // West Java (Jawa Barat) regencies
    0x1000, // Bogor
    
    // East Java (Jawa Timur) regencies
    0x8000, // Bojonegoro
    
    // North Sulawesi (Sulawesi Utara) regencies
    0x20000000, // Bolaang Mongondow
    0x20000000, // Bolaang Mongondow Selatan
    0x20000000, // Bolaang Mongondow Timur
    0x20000000, // Bolaang Mongondow Utara
    
    // Southeast Sulawesi (Sulawesi Tenggara) regencies
    0x8000000, // Bombana
    
    // East Java (Jawa Timur) regencies
    0x8000, // Bondowoso
    
    // South Sulawesi (Sulawesi Selatan) regencies
    0x2000000, // Bone
    
    // Gorontalo regencies
    0x10000000, // Bone Bolango
    
    // Papua regencies
    0x80000000, // Boven Digoel
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Boyolali
    0x2000, // Brebes
    
    // Bali regencies
    0x10000, // Buleleng
    
    // South Sulawesi (Sulawesi Selatan) regencies
    0x2000000, // Bulukumba
    
    // North Kalimantan (Kalimantan Utara) regencies
    0x800000, // Bulungan
    
    // Jambi regencies
    0x20, // Bungo
    
    // Central Sulawesi (Sulawesi Tengah) regencies
    0x4000000, // Buol
    
    // Maluku regencies
    0x40000000, // Buru
    0x40000000, // Buru Selatan
    
    // Southeast Sulawesi (Sulawesi Tenggara) regencies
    0x8000000, // Buton
    0x8000000, // Buton Selatan
    0x8000000, // Buton Tengah
    0x8000000, // Buton Utara
    
    // West Java (Jawa Barat) regencies
    0x1000, // Ciamis
    0x1000, // Cianjur
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Cilacap
    
    // West Java (Jawa Barat) regencies
    0x1000, // Cirebon
    
    // North Sumatra (Sumatera Utara) regencies
    0x2, // Dairi
    
    // Papua regencies
    0x80000000, // Deiyai
    
    // North Sumatra (Sumatera Utara) regencies
    0x2, // Deli Serdang
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Demak
    
    // West Sumatra (Sumatera Barat) regencies
    0x4, // Dharmasraya
    
    // Papua regencies
    0x80000000, // Dogiyai
    
    // West Nusa Tenggara (Nusa Tenggara Barat) regencies
    0x20000, // Dompu
    
    // Central Sulawesi (Sulawesi Tengah) regencies
    0x4000000, // Donggala
    
    // South Sumatra (Sumatera Selatan) regencies
    0x80, // Empat Lawang
    
    // East Nusa Tenggara (Nusa Tenggara Timur) regencies
    0x40000, // Ende
    
    // South Sulawesi (Sulawesi Selatan) regencies
    0x2000000, // Enrekang
    
    // West Papua regencies
    0x80000000, // Fak Fak
    
    // East Nusa Tenggara (Nusa Tenggara Timur) regencies
    0x40000, // Flores Timur
    
    // West Java (Jawa Barat) regencies
    0x1000, // Garut
    
    // Aceh regencies
    0x1, // Gayo Lues
    
    // Bali regencies
    0x10000, // Gianyar
    
    // Gorontalo regencies
    0x10000000, // Gorontalo
    0x10000000, // Gorontalo Utara
    
    // South Sulawesi (Sulawesi Selatan) regencies
    0x2000000, // Gowa
    
    // East Java (Jawa Timur) regencies
    0x8000, // Gresik
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Grobogan
    
    // Central Kalimantan (Kalimantan Tengah) regencies
    0x100000, // Gunung Mas
    
    // Yogyakarta (DIY) regencies
    0x4000, // Gunungkidul
    
    // North Maluku (Maluku Utara) regencies
    0x40000000, // Halmahera Barat
    0x40000000, // Halmahera Selatan
    0x40000000, // Halmahera Tengah
    0x40000000, // Halmahera Timur
    0x40000000, // Halmahera Utara
    
    // South Kalimantan (Kalimantan Selatan) regencies
    0x200000, // Hulu Sungai Selatan
    0x200000, // Hulu Sungai Tengah
    0x200000, // Hulu Sungai Utara
    
    // North Sumatra (Sumatera Utara) regencies
    0x2, // Humbang Hasundutan
    
    // Riau regencies
    0x8, // Indragiri Hilir
    0x8, // Indragiri Hulu
    
    // West Java (Jawa Barat) regencies
    0x1000, // Indramayu
    
    // Papua regencies
    0x80000000, // Intan Jaya
    0x80000000, // Jayapura
    0x80000000, // Jayawijaya
    
    // East Java (Jawa Timur) regencies
    0x8000, // Jember
    
    // Bali regencies
    0x10000, // Jembrana
    
    // South Sulawesi (Sulawesi Selatan) regencies
    0x2000000, // Jeneponto
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Jepara
    
    // East Java (Jawa Timur) regencies
    0x8000, // Jombang
    
    // West Papua regencies
    0x80000000, // Kaimana
    
    // Riau regencies
    0x8, // Kampar
    
    // Central Kalimantan (Kalimantan Tengah) regencies
    0x100000, // Kapuas
    
    // West Kalimantan (Kalimantan Barat) regencies
    0x80000, // Kapuas Hulu
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Karanganyar
    
    // Bali regencies
    0x10000, // Karangasem
    
    // West Java (Jawa Barat) regencies
    0x1000, // Karawang
    
    // Riau Islands (Kepulauan Riau) regencies
    0x10, // Karimun
    
    // North Sumatra (Sumatera Utara) regencies
    0x2, // Karo
    
    // Central Kalimantan (Kalimantan Tengah) regencies
    0x100000, // Katingan
    
    // Bengkulu regencies
    0x40, // Kaur
    
    // West Kalimantan (Kalimantan Barat) regencies
    0x80000, // Kayong Utara
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Kebumen
    
    // East Java (Jawa Timur) regencies
    0x8000, // Kediri
    
    // Papua regencies
    0x80000000, // Keerom
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Kendal
    
    // Bengkulu regencies
    0x40, // Kepahiang
    
    // Riau Islands (Kepulauan Riau) regencies
    0x10, // Kepulauan Anambas
    
    // Maluku regencies
    0x40000000, // Kepulauan Aru
    
    // West Sumatra (Sumatera Barat) regencies
    0x4, // Kepulauan Mentawai
    
    // Riau regencies
    0x8, // Kepulauan Meranti
    
    // North Sulawesi (Sulawesi Utara) regencies
    0x20000000, // Kepulauan Sangihe
    
    // South Sulawesi (Sulawesi Selatan) regencies
    0x2000000, // Kepulauan Selayar
    
    // North Sulawesi (Sulawesi Utara) regencies
    0x20000000, // Kepulauan Siau Tagulandang Biaro
    
    // North Maluku (Maluku Utara) regencies
    0x40000000, // Kepulauan Sula
    
    // North Sulawesi (Sulawesi Utara) regencies
    0x20000000, // Kepulauan Talaud
    
    // Maluku regencies
    0x40000000, // Kepulauan Tanimbar
    
    // Papua regencies
    0x80000000, // Kepulauan Yapen
    
    // Jambi regencies
    0x20, // Kerinci
    
    // West Kalimantan (Kalimantan Barat) regencies
    0x80000, // Ketapang
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Klaten
    
    // Bali regencies
    0x10000, // Klungkung
    
    // Southeast Sulawesi (Sulawesi Tenggara) regencies
    0x8000000, // Kolaka
    0x8000000, // Kolaka Timur
    0x8000000, // Kolaka Utara
    0x8000000, // Konawe
    0x8000000, // Konawe Kepulauan
    0x8000000, // Konawe Selatan
    0x8000000, // Konawe Utara
    
    // Jakarta (DKI Jakarta) administrative cities
    0x800, // Kota Administrasi Jakarta Barat
    0x800, // Kota Administrasi Jakarta Pusat
    0x800, // Kota Administrasi Jakarta Selatan
    0x800, // Kota Administrasi Jakarta Timur
    0x800, // Kota Administrasi Jakarta Utara
    
    // Maluku cities
    0x40000000, // Kota Ambon
    
    // East Kalimantan (Kalimantan Timur) cities
    0x400000, // Kota Balikpapan
    
    // Aceh cities
    0x1, // Kota Banda Aceh
    
    // Lampung cities
    0x200, // Kota Bandar Lampung
    
    // West Java (Jawa Barat) cities
    0x1000, // Kota Bandung
    0x1000, // Kota Banjar
    
    // South Kalimantan (Kalimantan Selatan) cities
    0x200000, // Kota Banjarbaru
    0x200000, // Kota Banjarmasin
    
    // Riau Islands (Kepulauan Riau) cities
    0x10, // Kota Batam
    
    // East Java (Jawa Timur) cities
    0x8000, // Kota Batu
    
    // Southeast Sulawesi (Sulawesi Tenggara) cities
    0x8000000, // Kota Bau Bau
    
    // West Java (Jawa Barat) cities
    0x1000, // Kota Bekasi
    
    // Bengkulu cities
    0x40, // Kota Bengkulu
    
    // West Nusa Tenggara (Nusa Tenggara Barat) cities
    0x20000, // Kota Bima
    
    // North Sumatra (Sumatera Utara) cities
    0x2, // Kota Binjai
    
    // North Sulawesi (Sulawesi Utara) cities
    0x20000000, // Kota Bitung
    
    // East Java (Jawa Timur) cities
    0x8000, // Kota Blitar
    
    // West Java (Jawa Barat) cities
    0x1000, // Kota Bogor
    
    // East Kalimantan (Kalimantan Timur) cities
    0x400000, // Kota Bontang
    
    // West Sumatra (Sumatera Barat) cities
    0x4, // Kota Bukittinggi
    
    // Banten cities
    0x400, // Kota Cilegon
    
    // West Java (Jawa Barat) cities
    0x1000, // Kota Cimahi
    0x1000, // Kota Cirebon
    
    // Bali cities
    0x10000, // Kota Denpasar
    
    // West Java (Jawa Barat) cities
    0x1000, // Kota Depok
    
    // Riau cities
    0x8, // Kota Dumai
    
    // Gorontalo cities
    0x10000000, // Kota Gorontalo
    
    // North Sumatra (Sumatera Utara) cities
    0x2, // Kota Gunungsitoli
    
    // Jambi cities
    0x20, // Kota Jambi
    
    // Papua cities
    0x80000000, // Kota Jayapura
    
    // East Java (Jawa Timur) cities
    0x8000, // Kota Kediri
    
    // Southeast Sulawesi (Sulawesi Tenggara) cities
    0x8000000, // Kota Kendari
    
    // North Sulawesi (Sulawesi Utara) cities
    0x20000000, // Kota Kotamobagu
    
    // East Nusa Tenggara (Nusa Tenggara Timur) cities
    0x40000, // Kota Kupang
    
    // Aceh cities
    0x1, // Kota Langsa
    0x1, // Kota Lhokseumawe
    
    // South Sumatra (Sumatera Selatan) cities
    0x80, // Kota Lubuk Linggau
    
    // East Java (Jawa Timur) cities
    0x8000, // Kota Madiun
    
    // Central Java (Jawa Tengah) cities
    0x2000, // Kota Magelang
    
    // South Sulawesi (Sulawesi Selatan) cities
    0x2000000, // Kota Makassar
    
    // East Java (Jawa Timur) cities
    0x8000, // Kota Malang
    
    // North Sulawesi (Sulawesi Utara) cities
    0x20000000, // Kota Manado
    
    // West Nusa Tenggara (Nusa Tenggara Barat) cities
    0x20000, // Kota Mataram
    
    // North Sumatra (Sumatera Utara) cities
    0x2, // Kota Medan
    
    // Lampung cities
    0x200, // Kota Metro
    
    // East Java (Jawa Timur) cities
    0x8000, // Kota Mojokerto
    
    // West Sumatra (Sumatera Barat) cities
    0x4, // Kota Padang
    0x4, // Kota Padang Panjang
    
    // North Sumatra (Sumatera Utara) cities
    0x2, // Kota Padang Sidempuan
    
    // South Sumatra (Sumatera Selatan) cities
    0x80, // Kota Pagar Alam
    
    // Central Kalimantan (Kalimantan Tengah) cities
    0x100000, // Kota Palangkaraya
    
    // South Sumatra (Sumatera Selatan) cities
    0x80, // Kota Palembang
    
    // South Sulawesi (Sulawesi Selatan) cities
    0x2000000, // Kota Palopo
    
    // Central Sulawesi (Sulawesi Tengah) cities
    0x4000000, // Kota Palu
    
    // Bangka Belitung cities
    0x100, // Kota Pangkal Pinang
    
    // South Sulawesi (Sulawesi Selatan) cities
    0x2000000, // Kota Pare Pare
    
    // West Sumatra (Sumatera Barat) cities
    0x4, // Kota Pariaman
    
    // East Java (Jawa Timur) cities
    0x8000, // Kota Pasuruan
    
    // West Sumatra (Sumatera Barat) cities
    0x4, // Kota Payakumbuh
    
    // Central Java (Jawa Tengah) cities
    0x2000, // Kota Pekalongan
    
    // Riau cities
    0x8, // Kota Pekanbaru
    
    // North Sumatra (Sumatera Utara) cities
    0x2, // Kota Pematangsiantar
    
    // West Kalimantan (Kalimantan Barat) cities
    0x80000, // Kota Pontianak
    
    // South Sumatra (Sumatera Selatan) cities
    0x80, // Kota Prabumulih
    
    // East Java (Jawa Timur) cities
    0x8000, // Kota Probolinggo
    
    // Aceh cities
    0x1, // Kota Sabang
    
    // Central Java (Jawa Tengah) cities
    0x2000, // Kota Salatiga
    
    // East Kalimantan (Kalimantan Timur) cities
    0x400000, // Kota Samarinda
    
    // West Sumatra (Sumatera Barat) cities
    0x4, // Kota Sawahlunto
    
    // Central Java (Jawa Tengah) cities
    0x2000, // Kota Semarang
    
    // Banten cities
    0x400, // Kota Serang
    
    // West Kalimantan (Kalimantan Barat) cities
    0x80000, // Kota Singkawang
    
    // West Sumatra (Sumatera Barat) cities
    0x4, // Kota Solok
    
    // West Papua cities
    0x80000000, // Kota Sorong
    
    // Aceh cities
    0x1, // Kota Subulussalam
    
    // West Java (Jawa Barat) cities
    0x1000, // Kota Sukabumi
    
    // Jambi cities
    0x20, // Kota Sungai Penuh
    
    // East Java (Jawa Timur) cities
    0x8000, // Kota Surabaya
    
    // Central Java (Jawa Tengah) cities
    0x2000, // Kota Surakarta
    
    // Banten cities
    0x400, // Kota Tangerang
    0x400, // Kota Tangerang Selatan
    
    // North Sumatra (Sumatera Utara) cities
    0x2, // Kota Tanjung Balai
    
    // Riau Islands (Kepulauan Riau) cities
    0x10, // Kota Tanjung Pinang
    
    // North Kalimantan (Kalimantan Utara) cities
    0x800000, // Kota Tarakan
    
    // West Java (Jawa Barat) cities
    0x1000, // Kota Tasikmalaya
    
    // North Sumatra (Sumatera Utara) cities
    0x2, // Kota Tebing Tinggi
    
    // Central Java (Jawa Tengah) cities
    0x2000, // Kota Tegal
    
    // North Maluku (Maluku Utara) cities
    0x40000000, // Kota Ternate
    0x40000000, // Kota Tidore Kepulauan
    
    // North Sulawesi (Sulawesi Utara) cities
    0x20000000, // Kota Tomohon
    
    // Maluku cities
    0x40000000, // Kota Tual
    
    // Yogyakarta (DIY) cities
    0x4000, // Kota Yogyakarta
    
    // South Kalimantan (Kalimantan Selatan) regencies
    0x200000, // Kotabaru
    
    // Central Kalimantan (Kalimantan Tengah) regencies
    0x100000, // Kotawaringin Barat
    0x100000, // Kotawaringin Timur
    
    // Riau regencies
    0x8, // Kuantan Singingi
    
    // West Kalimantan (Kalimantan Barat) regencies
    0x80000, // Kubu Raya
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Kudus
    
    // Yogyakarta (DIY) regencies
    0x4000, // Kulon Progo
    
    // West Java (Jawa Barat) regencies
    0x1000, // Kuningan
    
    // East Nusa Tenggara (Nusa Tenggara Timur) regencies
    0x40000, // Kupang
    
    // East Kalimantan (Kalimantan Timur) regencies
    0x400000, // Kutai Barat
    0x400000, // Kutai Kartanegara
    0x400000, // Kutai Timur
    
    // North Sumatra (Sumatera Utara) regencies
    0x2, // Labuhanbatu
    0x2, // Labuhanbatu Selatan
    0x2, // Labuhanbatu Utara
    
    // South Sumatra (Sumatera Selatan) regencies
    0x80, // Lahat
    
    // Central Kalimantan (Kalimantan Tengah) regencies
    0x100000, // Lamandau
    
    // East Java (Jawa Timur) regencies
    0x8000, // Lamongan
    
    // Lampung regencies
    0x200, // Lampung Barat
    0x200, // Lampung Selatan
    0x200, // Lampung Tengah
    0x200, // Lampung Timur
    0x200, // Lampung Utara
    
    // West Kalimantan (Kalimantan Barat) regencies
    0x80000, // Landak
    
    // North Sumatra (Sumatera Utara) regencies
    0x2, // Langkat
    
    // Papua regencies
    0x80000000, // Lanny Jaya
    
    // Banten regencies
    0x400, // Lebak
    
    // Bengkulu regencies
    0x40, // Lebong
    
    // East Nusa Tenggara (Nusa Tenggara Timur) regencies
    0x40000, // Lembata
    
    // West Sumatra (Sumatera Barat) regencies
    0x4, // Lima Puluh Kota
    
    // Riau Islands (Kepulauan Riau) regencies
    0x10, // Lingga
    
    // West Nusa Tenggara (Nusa Tenggara Barat) regencies
    0x20000, // Lombok Barat
    0x20000, // Lombok Tengah
    0x20000, // Lombok Timur
    0x20000, // Lombok Utara
    
    // East Java (Jawa Timur) regencies
    0x8000, // Lumajang
    
    // South Sulawesi (Sulawesi Selatan) regencies
    0x2000000, // Luwu
    0x2000000, // Luwu Timur
    0x2000000, // Luwu Utara
    
    // East Java (Jawa Timur) regencies
    0x8000, // Madiun
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Magelang
    
    // East Java (Jawa Timur) regencies
    0x8000, // Magetan
    
    // East Kalimantan (Kalimantan Timur) regencies
    0x400000, // Mahakam Ulu
    
    // West Java (Jawa Barat) regencies
    0x1000, // Majalengka
    
    // West Sulawesi (Sulawesi Barat) regencies
    0x1000000, // Majene
    
    // East Nusa Tenggara (Nusa Tenggara Timur) regencies
    0x40000, // Malaka
    
    // East Java (Jawa Timur) regencies
    0x8000, // Malang
    
    // North Kalimantan (Kalimantan Utara) regencies
    0x800000, // Malinau
    
    // Maluku regencies
    0x40000000, // Maluku Barat Daya
    0x40000000, // Maluku Tengah
    0x40000000, // Maluku Tenggara
    
    // West Sulawesi (Sulawesi Barat) regencies
    0x1000000, // Mamasa
    
    // Papua regencies
    0x80000000, // Mamberamo Raya
    0x80000000, // Mamberamo Tengah
    
    // West Sulawesi (Sulawesi Barat) regencies
    0x1000000, // Mamuju
    0x1000000, // Mamuju Tengah
    
    // North Sumatra (Sumatera Utara) regencies
    0x2, // Mandailing Natal
    
    // East Nusa Tenggara (Nusa Tenggara Timur) regencies
    0x40000, // Manggarai
    0x40000, // Manggarai Barat
    0x40000, // Manggarai Timur
    
    // West Papua regencies
    0x80000000, // Manokwari
    0x80000000, // Manokwari Selatan
    
    // Papua regencies
    0x80000000, // Mappi
    
    // South Sulawesi (Sulawesi Selatan) regencies
    0x2000000, // Maros
    
    // West Papua regencies
    0x80000000, // Maybrat
    
    // West Kalimantan (Kalimantan Barat) regencies
    0x80000, // Melawi
    
    // West Kalimantan (Kalimantan Barat) regencies
    0x80000, // Mempawah
    
    // Jambi regencies
    0x20, // Merangin
    
    // Papua regencies
    0x80000000, // Merauke
    
    // Lampung regencies
    0x200, // Mesuji
    
    // Papua regencies
    0x80000000, // Mimika
    
    // North Sulawesi (Sulawesi Utara) regencies
    0x20000000, // Minahasa
    0x20000000, // Minahasa Selatan
    0x20000000, // Minahasa Tenggara
    0x20000000, // Minahasa Utara
    
    // East Java (Jawa Timur) regencies
    0x8000, // Mojokerto
    
    // Central Sulawesi (Sulawesi Tengah) regencies
    0x4000000, // Morowali
    0x4000000, // Morowali Utara
    
    // South Sumatra (Sumatera Selatan) regencies
    0x80, // Muara Enim
    
    // Jambi regencies
    0x20, // Muaro Jambi
    
    // Bengkulu regencies
    0x40, // Muko Muko
    
    // Southeast Sulawesi (Sulawesi Tenggara) regencies
    0x8000000, // Muna
    0x8000000, // Muna Barat
    
    // Central Kalimantan (Kalimantan Tengah) regencies
    0x100000, // Murung Raya
    
    // South Sumatra (Sumatera Selatan) regencies
    0x80, // Musi Banyuasin
    0x80, // Musi Rawas
    0x80, // Musi Rawas Utara
    
    // Papua regencies
    0x80000000, // Nabire
    
    // Aceh regencies
    0x1, // Nagan Raya
    
    // East Nusa Tenggara (Nusa Tenggara Timur) regencies
    0x40000, // Nagekeo
    
    // Riau Islands (Kepulauan Riau) regencies
    0x10, // Natuna
    
    // Papua regencies
    0x80000000, // Nduga
    
    // East Nusa Tenggara (Nusa Tenggara Timur) regencies
    0x40000, // Ngada
    
    // East Java (Jawa Timur) regencies
    0x8000, // Nganjuk
    0x8000, // Ngawi
    
    // North Sumatra (Sumatera Utara) regencies
    0x2, // Nias
    0x2, // Nias Barat
    0x2, // Nias Selatan
    0x2, // Nias Utara
    
    // North Kalimantan (Kalimantan Utara) regencies
    0x800000, // Nunukan
    
    // South Sumatra (Sumatera Selatan) regencies
    0x80, // Ogan Ilir
    0x80, // Ogan Komering Ilir
    0x80, // Ogan Komering Ulu
    0x80, // Ogan Komering Ulu Selatan
    0x80, // Ogan Komering Ulu Timur
    
    // East Java (Jawa Timur) regencies
    0x8000, // Pacitan
    
    // North Sumatra (Sumatera Utara) regencies
    0x2, // Padang Lawas
    0x2, // Padang Lawas Utara
    
    // West Sumatra (Sumatera Barat) regencies
    0x4, // Padang Pariaman
    
    // Gorontalo regencies
    0x10000000, // Pahuwato
    
    // North Sumatra (Sumatera Utara) regencies
    0x2, // Pakpak Bharat
    
    // East Java (Jawa Timur) regencies
    0x8000, // Pamekasan
    
    // Banten regencies
    0x400, // Pandeglang
    
    // West Java (Jawa Barat) regencies
    0x1000, // Pangandaran
    
    // South Sulawesi (Sulawesi Selatan) regencies
    0x2000000, // Pangkajene Kepulauan
    
    // Papua regencies
    0x80000000, // Paniai
    
    // Central Sulawesi (Sulawesi Tengah) regencies
    0x4000000, // Parigi Moutong
    
    // West Sumatra (Sumatera Barat) regencies
    0x4, // Pasaman
    0x4, // Pasaman Barat
    
    // West Sulawesi (Sulawesi Barat) regencies
    0x1000000, // Pasangkayu
    
    // East Kalimantan (Kalimantan Timur) regencies
    0x400000, // Paser
    
    // East Java (Jawa Timur) regencies
    0x8000, // Pasuruan
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Pati
    
    // West Papua regencies
    0x80000000, // Pegunungan Arfak
    
    // Papua regencies
    0x80000000, // Pegunungan Bintang
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Pekalongan
    
    // Riau regencies
    0x8, // Pelalawan
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Pemalang
    
    // East Kalimantan (Kalimantan Timur) regencies
    0x400000, // Penajam Paser Utara
    
    // South Sumatra (Sumatera Selatan) regencies
    0x80, // Penukal Abab Lematang Ilir
    
    // Lampung regencies
    0x200, // Pesawaran
    0x200, // Pesisir Barat
    
    // West Sumatra (Sumatera Barat) regencies
    0x4, // Pesisir Selatan
    
    // Aceh regencies
    0x1, // Pidie
    0x1, // Pidie Jaya
    
    // South Sulawesi (Sulawesi Selatan) regencies
    0x2000000, // Pinrang
    
    // West Sulawesi (Sulawesi Barat) regencies
    0x1000000, // Polewali Mandar
    
    // East Java (Jawa Timur) regencies
    0x8000, // Ponorogo
    
    // Central Sulawesi (Sulawesi Tengah) regencies
    0x4000000, // Poso
    
    // Lampung regencies
    0x200, // Pringsewu
    
    // East Java (Jawa Timur) regencies
    0x8000, // Probolinggo
    
    // Central Kalimantan (Kalimantan Tengah) regencies
    0x100000, // Pulang Pisau
    
    // North Maluku (Maluku Utara) regencies
    0x40000000, // Pulau Morotai
    0x40000000, // Pulau Taliabu
    
    // Papua regencies
    0x80000000, // Puncak
    0x80000000, // Puncak Jaya
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Purbalingga
    
    // West Java (Jawa Barat) regencies
    0x1000, // Purwakarta
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Purworejo
    
    // West Papua regencies
    0x80000000, // Raja Ampat
    
    // Bengkulu regencies
    0x40, // Rejang Lebong
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Rembang
    
    // Riau regencies
    0x8, // Rokan Hilir
    0x8, // Rokan Hulu
    
    // East Nusa Tenggara (Nusa Tenggara Timur) regencies
    0x40000, // Rote Ndao
    0x40000, // Sabu Raijua
    
    // West Kalimantan (Kalimantan Barat) regencies
    0x80000, // Sambas
    
    // North Sumatra (Sumatera Utara) regencies
    0x2, // Samosir
    
    // East Java (Jawa Timur) regencies
    0x8000, // Sampang
    
    // West Kalimantan (Kalimantan Barat) regencies
    0x80000, // Sanggau
    
    // Papua regencies
    0x80000000, // Sarmi
    
    // Jambi regencies
    0x20, // Sarolangun
    
    // West Kalimantan (Kalimantan Barat) regencies
    0x80000, // Sekadau
    
    // Bengkulu regencies
    0x40, // Seluma
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Semarang
    
    // Maluku regencies
    0x40000000, // Seram Bagian Barat
    0x40000000, // Seram Bagian Timur
    
    // Banten regencies
    0x400, // Serang
    
    // North Sumatra (Sumatera Utara) regencies
    0x2, // Serdang Bedagai
    
    // Central Kalimantan (Kalimantan Tengah) regencies
    0x100000, // Seruyan
    
    // Riau regencies
    0x8, // Siak
    
    // South Sulawesi (Sulawesi Selatan) regencies
    0x2000000, // Sidenreng Rappang
    
    // East Java (Jawa Timur) regencies
    0x8000, // Sidoarjo
    
    // Central Sulawesi (Sulawesi Tengah) regencies
    0x4000000, // Sigi
    
    // West Sumatra (Sumatera Barat) regencies
    0x4, // Sijunjung
    
    // East Nusa Tenggara (Nusa Tenggara Timur) regencies
    0x40000, // Sikka
    
    // North Sumatra (Sumatera Utara) regencies
    0x2, // Simalungun
    
    // Aceh regencies
    0x1, // Simeulue
    
    // South Sulawesi (Sulawesi Selatan) regencies
    0x2000000, // Sinjai
    
    // West Kalimantan (Kalimantan Barat) regencies
    0x80000, // Sintang
    
    // East Java (Jawa Timur) regencies
    0x8000, // Situbondo
    
    // Yogyakarta (DIY) regencies
    0x4000, // Sleman
    
    // West Sumatra (Sumatera Barat) regencies
    0x4, // Solok
    0x4, // Solok Selatan
    
    // South Sulawesi (Sulawesi Selatan) regencies
    0x2000000, // Soppeng
    
    // West Papua regencies
    0x80000000, // Sorong
    0x80000000, // Sorong Selatan
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Sragen
    
    // West Java (Jawa Barat) regencies
    0x1000, // Subang
    0x1000, // Sukabumi
    
    // Central Kalimantan (Kalimantan Tengah) regencies
    0x100000, // Sukamara
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Sukoharjo
    
    // East Nusa Tenggara (Nusa Tenggara Timur) regencies
    0x40000, // Sumba Barat
    0x40000, // Sumba Barat Daya
    0x40000, // Sumba Tengah
    0x40000, // Sumba Timur
    
    // West Nusa Tenggara (Nusa Tenggara Barat) regencies
    0x20000, // Sumbawa
    0x20000, // Sumbawa Barat
    
    // West Java (Jawa Barat) regencies
    0x1000, // Sumedang
    
    // East Java (Jawa Timur) regencies
    0x8000, // Sumenep
    
    // Papua regencies
    0x80000000, // Supiori
    
    // South Kalimantan (Kalimantan Selatan) regencies
    0x200000, // Tabalong
    
    // Bali regencies
    0x10000, // Tabanan
    
    // South Sulawesi (Sulawesi Selatan) regencies
    0x2000000, // Takalar
    
    // West Papua regencies
    0x80000000, // Tambrauw
    
    // North Kalimantan (Kalimantan Utara) regencies
    0x800000, // Tana Tidung
    
    // South Sulawesi (Sulawesi Selatan) regencies
    0x2000000, // Tana Toraja
    
    // South Kalimantan (Kalimantan Selatan) regencies
    0x200000, // Tanah Bumbu
    
    // West Sumatra (Sumatera Barat) regencies
    0x4, // Tanah Datar
    
    // South Kalimantan (Kalimantan Selatan) regencies
    0x200000, // Tanah Laut
    
    // Banten regencies
    0x400, // Tangerang
    
    // Lampung regencies
    0x200, // Tanggamus
    
    // Jambi regencies
    0x20, // Tanjung Jabung Barat
    0x20, // Tanjung Jabung Timur
    
    // North Sumatra (Sumatera Utara) regencies
    0x2, // Tapanuli Selatan
    0x2, // Tapanuli Tengah
    0x2, // Tapanuli Utara
    
    // South Kalimantan (Kalimantan Selatan) regencies
    0x200000, // Tapin
    
    // West Java (Jawa Barat) regencies
    0x1000, // Tasikmalaya
    
    // Jambi regencies
    0x20, // Tebo
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Tegal
    
    // West Papua regencies
    0x80000000, // Teluk Bintuni
    0x80000000, // Teluk Wondama
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Temanggung
    
    // East Nusa Tenggara (Nusa Tenggara Timur) regencies
    0x40000, // Timor Tengah Selatan
    0x40000, // Timor Tengah Utara
    
    // North Sumatra (Sumatera Utara) regencies
    0x2, // Toba Samosir
    
    // Central Sulawesi (Sulawesi Tengah) regencies
    0x4000000, // Tojo Una Una
    0x4000000, // Toli Toli
    
    // Papua regencies
    0x80000000, // Tolikara
    
    // South Sulawesi (Sulawesi Selatan) regencies
    0x2000000, // Toraja Utara
    
    // East Java (Jawa Timur) regencies
    0x8000, // Trenggalek
    0x8000, // Tuban
    
    // Lampung regencies
    0x200, // Tulang Bawang
    0x200, // Tulang Bawang Barat
    
    // East Java (Jawa Timur) regencies
    0x8000, // Tulungagung
    
    // South Sulawesi (Sulawesi Selatan) regencies
    0x2000000, // Wajo
    
    // Southeast Sulawesi (Sulawesi Tenggara) regencies
    0x8000000, // Wakatobi
    
    // Papua regencies
    0x80000000, // Waropen
    
    // Lampung regencies
    0x200, // Way Kanan
    
    // Central Java (Jawa Tengah) regencies
    0x2000, // Wonogiri
    0x2000, // Wonosobo
    
    // Papua regencies
    0x80000000, // Yahukimo
    0x80000000 // Yalimo
];
